import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';

/**
 * Lands the SSO redirect (`/sso/callback?access_token=...&refresh_token=...`),
 * persists the tokens the same way the password login does, hydrates the user,
 * and forwards to the dashboard.
 */
export default function SsoCallbackPage() {
  const navigate = useNavigate();
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const access = params.get('access_token');
    const refresh = params.get('refresh_token');
    if (access) {
      localStorage.setItem('admin_access_token', access);
      if (refresh) localStorage.setItem('admin_refresh_token', refresh);
      // Force a re-validation, then go to the dashboard.
      useAuthStore.setState({ initialized: false });
      checkAuth().finally(() => navigate('/dashboard', { replace: true }));
    } else {
      navigate('/login', { replace: true });
    }
  }, [checkAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-3 text-gray-500">Completing sign-in…</p>
      </div>
    </div>
  );
}
